export const fallbacks = {
  Unassigned: 'Unassigned',
  Unavailable: 'Unavailable',
  Na: 'N/A',
} as const;
